import { IStyleProps } from '../../types/StyleProps';

const styles: IStyleProps = {};

export default styles;
